<div [formGroup]="group">
    <label class="font-weight-bold">FLIGHT SCHEDULE</label>
    <div class="flight-schedule">
        <table class="table table-bordered flight-schedule-table">
            <thead>
                <tr>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <th scope="col">Total Budget</th>
                    <!-- <th scope="col">Max Impressions</th> -->
                </tr>
            </thead>
            <tbody>
                <tr>
                    <!--START DATE-->
                    <td id="DL-startDate">
                        <acl-ngx-datepicker-button [formControl]="selectedStartDate" placeholderText="MM/DD/YYYY"
                            [maxDate]="maxDate" [error]="startDate.touched && startDate.errors"
                            (daySelected)="setStartDate($event)">
                        </acl-ngx-datepicker-button>
                    </td>
                    <!--END DATE-->
                    <td id="DL-endDate">
                        <acl-ngx-datepicker-button [formControl]="selectedEndDate" placeholderText="MM/DD/YYYY"
                            [maxDate]="maxDate" [error]="endDate.touched && endDate.errors"
                            (daySelected)="setEndDate($event)">
                        </acl-ngx-datepicker-button>
                    </td>
                    <!--BUDGET-->
                    <td id="DL-spendingCap">
                        <div class="acl-FormControl fluid">
                            <div class="acl-Input--table acl-Input-wrapper"
                                [ngClass]="{'acl-Input--error': spendingCap.touched && spendingCap.errors, 'acl-Input--disabled': spendingCap.disabled}">
                                <div class="acl-Input-leftElement">
                                    {{currencySymbol}}
                                </div>
                                <input type="text" placeholder="Budget" formControlName="spendingCap"
                                    maxlength="{{budgetLimit}}" currencyFormat>
                            </div>
                        </div>
                    </td>
                    <!--MAX IMPRESSIONS: Will be supported later on-->
                    <!-- <td>
                        <div class="input-group">
                            <input type="number" class="form-control font-italic" placeholder="Optional"
                                formControlName="impressionCap">
                        </div>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="group.touched && group.invalid" class="error-feedback">
        <div *ngIf="startDate.errors && startDate.errors.required">
            <span>Start Date can not be empty</span>
        </div>
        <div *ngIf="endDate.errors && endDate.errors.required">
            <span>End Date can not be empty</span>
        </div>
        <div *ngIf="group.errors && (group.errors.invalidDate || group.errors.invalidDateRange)">
            <span>End Date can not be in the past and must be at least one day later than Start Date</span>
        </div>
        <div *ngIf="group.errors && group.errors.invalidStartOrEndDateRange">
            <span>Start Date and End Date can not be more than 3 months in future</span>
        </div>
        <div *ngIf="spendingCap.errors && spendingCap.errors.greaterThanZero">
            <span>Budget can not be empty</span>
        </div>
    </div>
</div>
